<template>
  <div id="app">
    <Header :stock="stock" />
    <div class="head-blank">
      <body id="page-top">
        <!-- Header-->

        <carousel
          style="margin-top:90px;"
          :per-page="1"
          :mouse-drag="true"
          :autoplay="true"
        >
          <slide>
            <img
              src="./assets/img/6811img/cover1.jpg"
              class="d-block w-100"
              alt="1"
            />
          </slide>
          <slide>
            <img
              src="./assets/img/6811img/cover2.jpg"
              class="d-block w-100"
              alt="1"
            />
          </slide>
          <slide>
            <img
              src="./assets/img/6811img/cover3.jpg"
              class="d-block w-100"
              alt="1"
            />
          </slide>
        </carousel>

        <section>
          <div class="d-flex justify-content-between text-center ">
            <a
              type="button"
              class="btn-lg btn-primary m-2 w-100 mobile-display"
              :href="registerHref"
              style="background-color: #e0951e;
              border: 2px solid #fbc672;
              text-decoration:none"
            >
              สมัครสมาชิก
            </a>
            <a
              type="button"
              class="btn-lg btn-primary m-2 w-100 mobile-display"
              :href="loginHref"
              style="background-color: #336d0c; 
              border: 2px solid #fbc672; 
              text-decoration: none"
            >
              เข้าสู่ระบบ
            </a>
          </div>
          <div class="container">
            <div class="card">
              <div class="content">
                <div class="imgBx">
                  <img src="./assets/img/6811img/game1.jpg" />
                </div>
              </div>
              <ul class="sci">
                <li>
                  <a href="">ดูเพิ่มเติม</a>
                </li>
              </ul>
            </div>
            <div class="card">
              <div class="content">
                <div class="imgBx">
                  <img src="./assets/img/6811img/game2.jpg" />
                  />
                </div>
              </div>
              <ul class="sci">
                <li>
                  <a href="">ดูเพิ่มเติม</a>
                </li>
              </ul>
            </div>
            <div class="card">
              <div class="content">
                <div class="imgBx">
                  <img src="./assets/img/6811img/game3.jpg" />
                  />
                </div>
              </div>
              <ul class="sci">
                <li>
                  <a href="">ดูเพิ่มเติม</a>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <a :href="loginHref" target="_blank">
          <img
            width="2000"
            src="./assets/img/6811img/ufa6811.gif"
            class="d-block w-100"
            alt="1"
        /></a>

        <!-- Content section 1-->
        <div class="container-text">
          <section id="scroll">
            <div class="container px-5">
              <div class="row gx-5 align-items-center">
                <div class="col-lg-6 order-lg-2">
                  <div class="p-5">
                    <img
                      class="img-fluid"
                      src="./assets/img/6811img/a1.jpg"
                      alt="..."
                    />
                  </div>
                </div>
                <div class="col-lg-6 order-lg-1">
                  <div class="pt-4">
                    <h2 class="display-4">UFABET เว็บตรง</h2>
                    <p>
                      UFABET
                      หนึ่งในผู้นำด้านการพนันกีฬาและคาสิโนออนไลน์ชั้นนำของโลก
                      UFABET Sportsbook นำเสนอการแข่งขันกีฬากว่า 500
                      รายการทุกสัปดาห์
                      ด้วยการครอบคลุมอย่างกว้างขวางของลีกฟุตบอลที่สำคัญทั้งหมดและการแข่งขันกีฬาระดับนานาชาติ
                      UFABET ยังมีการอัพเดทฟุตบอลสด การยืนยันการชนะทันที
                      การจ่ายเงินอย่างรวดเร็ว
                      เข้าถึงได้ง่ายและการเดิมพันออนไลน์ที่รวดเร็วตลอดเวลา
                      UFABET
                      เลือกเทคโนโลยีล่าสุดในการจัดเตรียมสภาพแวดล้อมในการเล่นของผู้เล่น
                      ให้มีความรวดเร็วและปลอดภัยเสมอ ที่ UFABET
                      เราสัญญาที่จะมอบประสบการณ์การเล่นพนันและคาสิโนที่ยอดเยี่ยมให้กับลูกค้าของเรา
                      ไม่ว่าจะเป็นการพนันกีฬา สล็อต หรือบาคาร่า UFABET
                      นำเสนอผลิตภัณฑ์และบริการที่น่าสนใจและมีความหลากหลาย
                      เพื่อให้ตรงกับความต้องการของคุณ UFABET
                      เราพร้อมให้บริการทุกท่าน
                      ตั้งแต่นักพนันทั่วไปจนถึงผู้เล่นวีไอพีและนักพนันต่างชาติ
                      ยิ่งไปกว่านั้นทั้งหมดนี้
                      คุณสามารถใช้บิการของเราได้จากที่บ้านและทั่วทุกมุมโลก
                      หากคุณเลือกเล่นกับ UFABET แล้ว คุณจะมั่นใจได้เลยว่า
                      คุณกำลังติดต่อกับผู้ให้บริการออนไลน์ที่มีชื่อเสียงซึ่งผู้บริหารมีประสบการณ์หลายทศวรรษในอุตสาหกรรม
                      ทีมสนับสนุน UFABET
                      ที่เป็นมิตรของเราพร้อมให้ความช่วยเหลือในทุกวิถีทางที่เป็นไปได้รวมถึงการสอบถามเกี่ยวกับบัญชีการฝากหรือถอนเงิน
                      หรือความช่วยเหลือด้านการพนันทั่วไป
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- Content section 2-->
          <section>
            <div class="container px-5">
              <div class="row gx-5 align-items-center">
                <div class="col-lg-6">
                  <div>
                    <img
                      class="img-fluid"
                      src="./assets/img/6811img/a2.jpg"
                      alt="..."
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div>
                    <h2 class="display-4">Soccer Betting</h2>
                    <p>
                      ฟุตบอล เป็นกีฬาที่มีผู้ชมมากที่สุดในโลก
                      จึงไม่น่าแปลกใจที่การพนันฟุตบอลจะดึงดูดความสนใจได้เป็นอย่างมาก
                      ด้วยแฟนบอลประมาณ 3.5
                      พันล้านคนในโลกเกือบครึ่งหนึ่งของประชากรทั้งหมด!
                      คนจำนวนมากดูฟุตบอลมากกว่ากีฬาประเภทอื่นและมีแฟน ๆ
                      จำนวนมากขึ้นที่ต้องการทดสอบความรู้ฟุตบอลโดยการเดิมพันกับ
                      UFA6811 แฟน ๆ เหล่านี้บางคนเล่นบางครั้งคราว
                      หรือเป็นนักพนันเพื่อสันทนาการและอื่น ๆ
                      ที่ชอบที่เล่นอย่างจริงจังโดยมีแรงจูงใจในการทำกำไรให้เกิดอย่างสม่ำเสมอ
                      UFA6811
                      ยินดีต้อนรับนักพนันทุกประเภทและยินดีให้ความช่วยเหลือคุณตลอด
                      24 ชั่วโมงทุกวัน
                      การเดิมพันฟุตบอลจำเป็นต้องมีการตัดสินใจสำคัญ
                      เกมใดที่จะวางเดิมพัน เดิมพันที่จะวาง และกลยุทธ์ใดที่จะใช้
                      เป็นปัจจัยสำคัญทั้งหมด ในการสร้างผลกำไรที่ยิ่งใหญ่
                      จึงเป็นสิ่งสำคัญที่การตัดสินใจ ต้องถูกต้อง
                      อีกหนึ่งปัจจัยที่สำคัญในการทำเงินคือการวางเดิมพัน
                      การพนันฟุตบอลออนไลน์เป็นที่นิยมมากที่สุดในทุกวันนี้และมีข้อได้เปรียบดังต่อไปนี้
                      แน่นอนว่าข้อดีเหล่านี้จะเกิดขึ้นได้ก็ต่อเมื่อคุณเลือกเว็บไซต์เดิมพันที่ถูกต้องเท่านั้น
                      การเลือกเว็บไซต์การพนันฟุตบอลอย่าง UFA6811 ที่มีชื่อเสียง
                      เชื่อถือได้และให้บริการที่มีคุณภาพ
                      เป็นส่วนสำคัญของความสำเร็จในการเดิมพันของคุณ ด้วย UFA6811
                      คุณมีทางเลือกมากมายสำหรับตัวเลือกการเดิมพันที่หลากหลายในทุกลีกฟุตบอล
                      ลงทะเบียนวันนี้เพื่อเริ่มเดิมพันฟุตบอลและรับรางวัลใหญ่กับ
                      UFA6811
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- Content section 3-->
          <section>
            <div class="container px-5">
              <div class="row gx-5 align-items-center">
                <div class="col-lg-6 order-lg-2">
                  <div>
                    <img
                      class="img-fluid"
                      src="./assets/img/6811img/a3.jpg"
                      alt="..."
                    />
                  </div>
                </div>
                <div class="col-lg-6 order-lg-1">
                  <div>
                    <h2 class="display-4">สล็อตเว็บตรง</h2>
                    <p>
                      เว็บสล็อตออนไลน์
                      เจ้าใหญ่ในเอเชียที่คัดสรรแต่สิ่งที่ดีที่สุดมาให้บริการด้วยคุณภาพ
                      สล็อตเว็บตรง
                      ทางเว็บไซต์ของเรานั้นได้รับความไว้วางใจจากเหล่านักเดิมพันในแถบเอเชียและเข้ามาใช้บริการ
                      กันอย่างล้นหลาม pgสล็อต slot
                      จนในปัจจุบันเราเป็นผู้ให้บริการระดับแนวหน้าที่มาแรงที่สุดแห่งยุค
                      สล็อตเว็บตรง ฝาก-ถอน true wallet ไม่มี ขั้น ต่ํา
                      อัดแน่นไปด้วยความสนุกของเกมดีมาให้นักเดิมพันได้สัมผัสประสบการณ์กันอย่างเต็มที่
                      รับประกันเลยว่าหากท่านได้เข้ามาลิ้มลองความสนุกกับทางเว็บไซต์ของเราที่นี่สักครั้ง
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div class="tt_r  tt_box_chat">
          <div class="tt_l  tt_h_chat">
            <a :href="lineHref" target="_blank" rel="nofollow"
              ><img
                src="./assets/img/b-line.png"
                class="entered lazyloaded"
                data-ll-status="loaded"
                width="36px"
              />
              <strong>@UFA6811</strong> <i class="fa fa-times-circle"></i>
            </a>
          </div>
        </div>
        <!-- Footer-->
        <footer class="py-5 bg-black">
          <div class="container px-5">
            <p class="m-0 text-center text-white small">
              Copyright &copy; UFA6811
            </p>
          </div>
        </footer>
      </body>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Header.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "app",
  computed: {
    lineHref: function() {
      return process.env.VUE_APP_LINE_HREF;
    },
    loginHref: function() {
      return process.env.VUE_APP_LOGIN_HREF;
    },
    registerHref: function() {
      return process.env.VUE_APP_REGISTER_HREF;
    },
  },
  components: { Header, Carousel, Slide },
  data() {
    return {};
  },

  mounted() {},
  methods: {},
};
</script>

<style>
.container {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.container .card {
  cursor: pointer;
  position: relative;
  height: 154px;
  background: rgba(255, 255, 255, 0);
  margin: 20px;
  display: flex;
  align-items: center;
  backdrop-filter: blur(10px);
}

.container-text {
  position: relative;

  background: rgba(255, 255, 255, 0.05);
  margin: 10px 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
}

.container .card .content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: 0.5s;
}

.container .card:hover .content {
  transform: translateY(-20px);
}

.container .card .content .imgBx {
  position: relative;
  width: 379px;
  height: 150px;
  overflow: hidden;
}

.container .card .content .imgBx img {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.container .card .content .contentBx h3 {
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  margin: 20px 0 10px;
  line-height: 1.1em;
}

.container .card .content .contentBx h3 span {
  font-size: 12px;
  font-weight: 300;
  text-transform: initial;
}

.container .card .sci {
  position: absolute;
  bottom: 50px;
  display: flex;
}

.container .card .sci li {
  list-style: none;
  margin: 0 10px;
  transform: translateY(40px);
  transition: 0.5s;
  opacity: 0;
}

.container .card:hover .sci li {
  transform: translateY(0px);
  opacity: 1;
}

.container .card .sci li a {
  text-decoration: none;
  color: #fff;
  font-size: 20px;
}

h2 {
  color: #fff;
  font-size: 25px !important;
  font-weight: bold !important;
  color: orange;
}
p {
  color: #fff;
}

.tt_box_chat {
  position: fixed;
  right: 20px;
  bottom: 20px;
  border-radius: 10px 10px 10px 10px;
  width: 150px;
  height: 50px;
  z-index: 100;
  overflow: hidden;
}

.tt_box_chat .tt_h_chat {
  float: left;
  width: 100%;
  border-radius: 10px 10px 10px 10px;
  padding: 5px 10px 5px 5px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  font-weight: 700;
  cursor: pointer;
  background: #32c238;
  border: 0;
}
.tt_box_chat a {
  color: #fff;
  text-decoration: none;
}
.tt_box_chat a:hover {
  color: #fff;
}

a {
  color: black;
}
a:hover {
  color: rgb(56, 56, 56);
}
.mobile-menu {
  display: flex;
  position: absolute;
  z-index: 20;
}
.head-mobile {
  background: linear-gradient(
    90deg,
    rgba(255, 136, 0, 0.308) 0%,
    rgba(255, 136, 0, 0.075) 100%
  );
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.test {
  background-color: rgba(255, 197, 110, 0.6);

  background: linear-gradient(
    90deg,
    rgba(255, 197, 110) 0%,
    rgba(255, 197, 110, 0.6) 100%
  );
}

.link-in {
  color: #fbc672;
  text-align: center;
  text-decoration: none;
  border-radius: 50px;
  border: 1.5px solid #fbc672;
  transition: all 0.6s;
  cursor: pointer;
}
.link-in:hover {
  color: #fff;
  border: 1.5px solid #fff;
  text-decoration: none;
}
.bm-burger-button {
  top: 14px !important;
}
.bm-burger-bars {
  background-color: #fbc672 !important;
}
.navbar-toggler {
  display: none !important;
}
.mobile-display {
  display: block !important;
}

@media screen and (min-width: 991px) {
  .mobile-display {
    display: none !important;
  }
}
</style>
